module.exports = __webpack_public_path__ + "img/hz_7.2c768291.jpg";